export const pennylaneQuoteStatusLabels: Record<string, string> = {
  Pending: 'En attente',
  Accepted: 'Accepté',
  Denied: 'Refusé',
  Invoiced: 'Facturé',
  Expired: 'Expiré',
};

export const pennylaneCustomerInvoiceStatusLabels: Record<string, string> = {
  Archived: 'Archivée',
  Incomplete: 'Incomplète',
  Cancelled: 'Annulée',
  Paid: 'Payée',
  PartiallyPaid: 'Partiellement payée',
  PartiallyCancelled: 'Partiellement annulée',
  Upcoming: 'À venir',
  Late: 'En retard',
  Draft: 'Brouillon',
  CreditNote: 'Avoir',
  Proforma: 'Proforma',
  ShippingOrder: 'Bon de livraison',
  PurchasingOrder: 'Bon de commande',
  EstimatePending: 'Estimation en attente',
  EstimateAccepted: 'Estimation acceptée',
  EstimateInvoiced: 'Estimation facturée',
  EstimateDenied: 'Estimation refusée',
};

export const pennylanePaymentStatusLabels: Record<string, string> = {
  Initiated: 'Initié',
  Pending: 'En attente',
  Emitted: 'Émis',
  Found: 'Trouvé',
  NotFound: 'Non trouvé',
  Aborted: 'Abandonné',
  Error: 'Erreur',
  Refunded: 'Remboursé',
  Prepared: 'Préparé',
  PendingCustomerApproval: "En attente d'approbation",
  PendingSubmission: 'En attente de soumission',
  Submitted: 'Soumis',
  Confirmed: 'Confirmé',
  PaidOut: 'Versé',
  Cancelled: 'Annulé',
  CustomerApprovalDenied: 'Approbation refusée',
  Failed: 'Échoué',
  ChargedBack: 'Remboursé (contestation)',
  ResubmissionRequested: 'Nouvelle soumission demandée',
  Draft: 'Brouillon',
};
